import { getAllObras, saveObra, updateObra } from '@/services/api/obra.js';
export const actions = {
  async getAllObras(state) {
    try {
      const dataList = await getAllObras();
      state.commit('SET_LIST', dataList);
      return dataList;
    } catch (error) {
      state.dispatch(
        'modal/showModal',
        {
          title: 'Erro ao processar a requisição!',
          message: 'Se o problema persistir, favor contatar o suporte.',
          buttonText: 'VOLTAR',
        },
        {
          root: true,
        }
      );
    }
  },
  async saveObra(state, payload) {
    try {
      await saveObra(payload);
    } catch (error) {
      state.dispatch(
        'modal/showModal',
        {
          title: 'Cadastro realizado',
          message: `Cadastrado com sucesso.`,
          buttonText: 'FECHAR',
        },
        {
          root: true,
        }
      );
    }
  },
  async updateObra(state, payload) {
    try {
      await updateObra(payload);
    } catch (error) {
      /* eslint-disable */
      console.log(error)
      state.dispatch(
        'modal/showModal',
        {
          title: 'Cadastro Atualizado',
          message: `Editado com sucesso.`,
          buttonText: 'FECHAR',
        },
        {
          root: true,
        }
      );
    }
  }
}
